var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "jss552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_301_37738)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    fill: "#0E9CF0",
    fillOpacity: 0.08
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 27.3C11.8638 27.3 7.7 23.1362 7.7 18C7.7 12.8638 11.8638 8.7 17 8.7C20.3451 8.7 23.2778 10.4661 24.9163 13.1168L26.0686 11.7725C24.0854 8.88992 20.7634 7 17 7C10.9249 7 6 11.9249 6 18C6 24.0751 10.9249 29 17 29C23.0751 29 28 24.0751 28 18C28 16.9625 27.8564 15.9585 27.5879 15.0069V15.5L26.2033 16.6538C26.267 17.0934 26.3 17.5428 26.3 18C26.3 23.1362 22.1362 27.3 17 27.3Z",
    fill: "#0E9CF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5883 16.9231L18.2039 21.3169C18.6014 21.6952 19.2294 21.6826 19.6113 21.2887L29.5883 11",
    stroke: "#0E9CF0",
    strokeWidth: 1.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_301_37738",
    x: -4,
    y: -4,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_301_37738"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_301_37738",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIcon);
export default __webpack_public_path__ + "static/media/checkmarkIcon.079e7ee818bfa0c9f315eeafe8ff16e5.svg";
export { ForwardRef as ReactComponent };